import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiFactoryService} from '../../../../shared/services/api-factory.service';
import {CrudHelpsService} from '../../../../shared/services/crud-helps.service';
import {CrudToolsService} from '@shared/services/crud-tools.service';
import {AbstractCrudEditComponent} from '@shared/library/crud-library/abstract-crud-edit.component';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {AlertService} from '@shared/services/alert.service';

@Component({
  selector: 'app-helps-edit',
  templateUrl: './helps-edit.component.html',
  styleUrls: ['./helps-edit.component.scss']
})
export class HelpsEditComponent extends AbstractCrudEditComponent {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected helpService: CrudHelpsService,
    protected toolService: CrudToolsService,
    protected apifactory: ApiFactoryService,
    protected alertService: AlertService
  ) {
    super(activatedRoute, router, apifactory, helpService, alertService);

    // Create form fields
    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'appclient_fkid',
                type: 'ng-select',
                defaultValue: 0,
                templateOptions: { label: 'Client', required: true, closeOnSelect: true },
                hooks: {
                  onInit: this.initAppClient
                }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'aoptools',
                type: 'ng-select',
                templateOptions: {
                  label: 'Restricted to tools',
                  options: [],
                  multiple: true,
                  selectableGroup: true,
                  selectableGroupAsModel: false,
                  clearable: true,
                  groupBy: (c) => c.groupLabel
                },
                hooks: {
                  onInit: this.initTools
                }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'label',
                type: 'input',
                templateOptions: { label: 'Label', required: true }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'sort',
                type: 'input',
                defaultValue: 0,
                templateOptions: { label: 'Sort' }
              }
            ]
          },
          {
            template: '<div class="col-12 pb-2 pt-1"><strong>English</strong></div>',
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'title_en',
                type: 'input',
                templateOptions: { label: 'Title', required: true }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'content_en',
                type: 'editor',
                templateOptions: { label: 'Content', required: true }
              }
            ]
          },
          {
            template: '<div class="col-12 pb-2 pt-1"><strong>French</strong></div>',
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'title_fr',
                type: 'input',
                templateOptions: { label: 'Title', required: true }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'content_fr',
                type: 'editor',
                templateOptions: { label: 'Content', required: true }
              }
            ]
          },
          {
            template: '<div class="col-12 pb-2 pt-1"><strong>German</strong></div>',
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'title_de',
                type: 'input',
                templateOptions: { label: 'Title', required: true }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'content_de',
                type: 'editor',
                templateOptions: { label: 'Content', required: true }
              }
            ]
          }
        ]
      }
    ];

    // Set form titles and entity path
    this.createSectionTitle = 'Create help section';
    this.updatePrefixTitle = 'Edit help section:';
    this.entityrooturl = '/admin/helps';
  }

  /*
   * Form fields functions for dynamic values
   */
  initAppClient = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    const query = this.bffapi.getClients();
    query.subscribe((data) => {
      const clients = data.results;
      typedField.templateOptions.options = [{label: 'Global', id: 0}, ...clients];
    });
  }

  initTools = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    const queryTools = this.toolService.getEntities();
    queryTools.subscribe((data) => {
      const clientControl = typedField.form.get('appclient_fkid');
      // tslint:disable-next-line:max-line-length
      const tools = data.results.map((t) => ({id: t.id, groupLabel: this.getToolGroupLabel(t.keyword), label: t.keyword, clientid: t.clientid}));
      typedField.templateOptions.options = tools.filter(
        t => !this.model.appclient_fkid || this.model.appclient_fkid === null || t.clientid === this.model.appclient_fkid
      );
      clientControl.valueChanges.subscribe(id => {
        if (id === 0) {
          typedField.templateOptions.options = tools;
        } else {
          typedField.templateOptions.options = tools.filter(t => t.clientid === id);
        }
      });
    });
  }

  getToolGroupLabel = (keyword: string) => {
    if (keyword.toLowerCase().indexOf('aos') !== -1) {
      return 'AOS';
    } else if (keyword.toLowerCase().indexOf('cavok') !== -1) {
      return 'Cavok';
    } else if (keyword.toLowerCase().indexOf('businesscard') !== -1 || keyword.toLowerCase().indexOf('bc') !== -1) {
      return 'Business cards';
    } else if (keyword.toLowerCase().indexOf('imagebank') !== -1) {
      return 'Image Bank';
    } else if (keyword.toLowerCase().indexOf('dos') !== -1) {
      return 'DOS';
    } else if (keyword.toLowerCase().indexOf('campaign-viewer') !== -1) {
      return 'Campaign Viewer';
    } else if (keyword.toLowerCase().indexOf('instore') !== -1) {
      return 'InStore';
    } else if (keyword.toLowerCase().indexOf('filemaker') !== -1) {
      return 'Filemaker';
    }
    return 'Other tools';
  }
}
